import { Col, Row } from 'antd';
import React from 'react';

const ZenMultiLines = ({ visible, classes = '', style = {}, singleLineColumns, multiLineColumns }) => {

    const singleLineContainer = (
        <div className='single-line'>
            {
                singleLineColumns.length ?
                    singleLineColumns.map((line, i) => (
                        <p key={i} style={line.style}>{line.text}</p>
                    )) : <></>
            }
        </div>
    )

    const multiLineContainer = (
        <div className='multi-line'>
            {
                multiLineColumns.length ?
                    multiLineColumns.map((list, mIndex) => (
                        <Row key={mIndex}>
                            {
                                list.map((item, idx) => (
                                    <Col key={idx} span={item.colSize}>
                                        {
                                            item.typ != 'blankSpace' && (
                                                <p style={{ marginBottom: 0 }}>
                                                    <span style={item.key.style}>{item.key.text}</span>
                                                    <span style={item.key.style}>:</span>
                                                    <span style={item.val.style}>{item.val.text}</span>
                                                </p>
                                            )
                                        }
                                    </Col>
                                ))
                            }
                        </Row>
                    )) : <></>
            }
        </div>
    )

    const mainContent = visible ? (
        <div className={`container ${classes}`} style={{ ...style, padding: 15 }}>
            {singleLineContainer}
            {multiLineContainer}
        </div>
    ) : (
        <></>
    )


    return mainContent
};

export default ZenMultiLines;